import * as axios from 'axios';

export const baserUrl = `https://api-cpl.mici.gob.pa`;

export class HealthService {
    static async getHealth() {
        try {
            let response = await axios.request({
                url: `${baserUrl}/health`,
                method: 'get'
            });
            return response.data;
        } catch(e) {
            console.error(e);
        }
    }
}

export class VersionService {
    static async getVersion() {
        try {
            let response = await axios.request({
                url: `${baserUrl}/version`,
                method: 'get'
            });
            return response.data.version;
        } catch(e) {
            console.error(e);
        }
    }
}

export class AuthenticationService {
    static circuitBreakerCallback = () => {};

    static async authenticate(email, password) {
        let response = await axios.post(`${baserUrl}/auth`, {email, password});
        return response.data.token;
    }

    static async decode(token) {
        try {
            let response = await axios.request({
                url: `${baserUrl}/auth/decode`,
                headers: {
                    'Authorization': token
                }
            });
            return response.data;
        } catch(e) {
            AuthenticationService.handleCircuitBreak(e);
        }
    }

    static handleCircuitBreak(e) {
        if(!!e.response && !!e.response.data && e.response.data.code === 'INVALID_TOKEN') {
            AuthenticationService.circuitBreakerCallback();
        } else {
            throw e;
        }
    }
}

export class UserService {
    static token = null;

    static setToken(token){
        UserService.token = token;
    }

    static getToken() {
        return UserService.token || localStorage.getItem('token');
    }

    static async getMe(token) {
        try {
            let response = await axios.request({
                url: `${baserUrl}/auth/decode`,
                headers: {
                    'Authorization': token
                }
            });
            return response.data;
        } catch(e) {
            AuthenticationService.handleCircuitBreak(e);
        }
    }

    static async getUsers() {
        try {
            let response = await axios.request({
                url: `${baserUrl}/users`,
                headers: {
                    'Authorization': UserService.getToken()
                }
            });
            return response.data;
        } catch(e) {
            AuthenticationService.handleCircuitBreak(e);
        }
    }

    static async createUser(user) {
        try {
            let response = await axios.request({
                url: `${baserUrl}/users`,
                method: 'post',
                headers: {
                    'Authorization': UserService.getToken()
                },
                data: user
            });
            return response.data;
        } catch(e) {
            AuthenticationService.handleCircuitBreak(e);
        }
    }

    static async updateUser(user) {
        try {
            let response = await axios.request({
                url: `${baserUrl}/users/${user.UserID}`,
                method: 'put',
                headers: {
                    'Authorization': UserService.getToken()
                },
                data: user
            });
            return response.data;
        } catch(e) {
            AuthenticationService.handleCircuitBreak(e);
        }
    }

    static async deleteUser(UserID) {
        try {
            let response = await axios.request({
                url: `${baserUrl}/users/${UserID}`,
                method: 'delete',
                headers: {
                    'Authorization': UserService.getToken()
                }
            });
            return response.data;
        } catch(e) {
            AuthenticationService.handleCircuitBreak(e);
        }
    }
}

export class CommerceService {
    static token = null;

    static setToken(token){
        CommerceService.token = token;
    }

    static getToken() {
        return CommerceService.token || localStorage.getItem('token');
    }

    static async getAllCommerces() {
        try {
            let response = await axios.request({
                url: `${baserUrl}/commerces`,
                headers: {
                    'Authorization': CommerceService.getToken()
                }
            });
            return response.data;
        } catch(e) {
            AuthenticationService.handleCircuitBreak(e);
        }
    }

    static async getByID(id) {
        
        try {
            let response = await axios.request({
                url: `${baserUrl}/commerces/${id}`,
                headers: {
                    'Authorization': CommerceService.getToken()
                }
            });
            return response.data;
        } catch(e) {
            AuthenticationService.handleCircuitBreak(e);
        }
    }

    static async downloadResolution(id, errorMessage) {
        try {
            let response = await axios.request({
                url: `${baserUrl}/commerces/${id}/resolution`,
                headers: {
                    'Authorization': CommerceService.getToken()
                },
                responseType: 'blob'
            });

            const downloadUrl = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = downloadUrl;
            link.setAttribute('download', `commerce-resolution-${id}.pdf`);
            document.body.appendChild(link);
            link.click();
            link.remove();
        } catch(e) {
            alert(errorMessage);
        }
    }

    static async getHistory(id) {
        try {
            let response = await axios.request({
                url: `${baserUrl}/commerces/${id}/history`,
                headers: {
                    'Authorization': CommerceService.getToken()
                }
            });
            return response.data;
        } catch(e) {
            AuthenticationService.handleCircuitBreak(e);
        }
    }

    static async updateStatus(id, status, resolution, justification) {
        try {
            const data = new FormData();
            data.append('resolution', resolution);
            data.append('status', status);
            data.append('rejectJustification', justification);

            let response = await axios.request({
                url: `${baserUrl}/commerces/${id}`,
                method: 'put',
                headers: {
                    'Authorization': CommerceService.getToken()
                },
                data: data
            });
            return response.data;
        } catch(e) {
            AuthenticationService.handleCircuitBreak(e);
        }
    }

    static async getDocuments(id) {
        try {
            let response = await axios.request({
                url: `${baserUrl}/commerces/${id}/documents`,
                headers: {
                    'Authorization': CommerceService.getToken()
                }
            });
            return response.data;
        } catch(e) {
            AuthenticationService.handleCircuitBreak(e);
        }
    }

    static async downloadDocument(CommerceID, id) {
        try {
            let response = await axios.request({
                url: `${baserUrl}/commerces/${CommerceID}/documents/download/${id}`,
                responseType: 'blob',
                headers: {
                    'Authorization': CommerceService.getToken()
                }
            });
            return response.data;
        } catch(e) {
            AuthenticationService.handleCircuitBreak(e);
        }
    }
}

export class DocumentService {
    static token = null;

    static setToken(token){
        DocumentService.token = token;
    }

    static getToken() {
        return DocumentService.token || localStorage.getItem('token');
    }

    static async getAllDocuments() {
        try {
            let response = await axios.request({
                url: `${baserUrl}/documents`,
                headers: {
                    'Authorization': DocumentService.getToken()
                }
            });
            return response.data;
        } catch(e) {
            AuthenticationService.handleCircuitBreak(e);
        }
    }
    static async createDocument(document) {
        try {
            let data = new FormData();
            data.append('document_file', document.file);
            delete document.file;

            data.append('data', JSON.stringify(document));

            let response = await axios.request({
                url: `${baserUrl}/documents`,
                method: 'post',
                headers: {
                    'Authorization': DocumentService.getToken()
                },
                data: data
            });
            return response.data;
        } catch(e) {
            AuthenticationService.handleCircuitBreak(e);
        }
    }

    static async updateDocument(document) {
        try {
            let data = new FormData();
            if(!!document.file) {
                data.append('document_file', document.file);
                delete document.file;
            }

            data.append('data', JSON.stringify(document));

            let response = await axios.request({
                url: `${baserUrl}/documents/${document.id}`,
                method: 'put',
                headers: {
                    'Authorization': DocumentService.getToken()
                },
                data: data
            });
            return response.data;
        } catch(e) {
            AuthenticationService.handleCircuitBreak(e);
        }
    }

    static async deleteDocument(id) {
        try {
            let response = await axios.request({
                url: `${baserUrl}/documents/${id}`,
                method: 'delete',
                headers: {
                    'Authorization': DocumentService.getToken()
                }
            });
            return response.data;
        } catch(e) {
            AuthenticationService.handleCircuitBreak(e);
        }
    }

    static async downloadDocument(id) {
        try {
            let response = await axios.request({
                url: `${baserUrl}/documents/${id}/download`,
                responseType: 'blob',
                headers: {
                    'Authorization': DocumentService.getToken()
                }
            });
            return response.data;
        } catch(e) {
            AuthenticationService.handleCircuitBreak(e);
        }
    }
}

export class ContentService {
    static token = null;

    static setToken(token){
        ContentService.token = token;
    }

    static getToken() {
        return ContentService.token || localStorage.getItem('token');
    }

    static async getAll() {
        try {
            let response = await axios.request({
                url: `${baserUrl}/contents`,
                headers: {
                    'Authorization': ContentService.getToken()
                }
            });
            return response.data;
        } catch(e) {
            AuthenticationService.handleCircuitBreak(e);
        }
    }
    static async create(content) {       
        try {
            let data = new FormData();
            
            if(content.type === 'news' || content.type === 'event') {
                if(!!content.coverImage) {
                    data.append('primary_image', content.coverImage);
                    delete content.coverImage;
                }
    
                if(!!content.thumbnailImage) {
                    data.append('thumbnail', content.thumbnailImage);
                    delete content.thumbnailImage;
                }
            }
            
            data.append('data', JSON.stringify(content));

            let response = await axios.request({
                url: `${baserUrl}/contents`, 
                method: 'post',
                headers: {
                    'Authorization': ContentService.getToken(),
                    'Content-Type': 'multipart/form-data'
                },
                data: data
            });
            return response.data;
        } catch(e) {
            AuthenticationService.handleCircuitBreak(e);
        }
    }

    static async update(content) {
        try {
            let data = new FormData();
            if(!!content.coverImage) {
                data.append('primary_image', content.coverImage);
                delete content.coverImage;
            }

            if(!!content.thumbnailImage) {
                data.append('thumbnail', content.thumbnailImage);
                delete content.thumbnailImage;
            }

            data.append('data', JSON.stringify(content));

            let response = await axios.request({
                url: `${baserUrl}/contents/${content.id}`,
                method: 'put',
                headers: {
                    'Authorization': ContentService.getToken()
                },
                data: data
            });
            return response.data;
        } catch(e) {
            AuthenticationService.handleCircuitBreak(e);
        }
    }

    static async delete(id) {
        try {
            let response = await axios.request({
                url: `${baserUrl}/contents/${id}`,
                method: 'delete',
                headers: {
                    'Authorization': ContentService.getToken()
                }
            });
            return response.data;
        } catch(e) {
            AuthenticationService.handleCircuitBreak(e);
        }
    }

    static async uploadImage(id, image) {
        try {
            let data = new FormData();
            data.append('image', image);

            let response = await axios.request({
                url: `${baserUrl}/contents/${id}/images`,
                method: 'post',
                headers: {
                    'Authorization': ContentService.getToken()
                },
                data: data
            });
            return {
                success: 1,
                file: {
                    url: `${baserUrl}/contents/${id}/images/${response.data.filename}`
                }
            };
        } catch(e) {
            AuthenticationService.handleCircuitBreak(e);
        }
    }
}

export class EmailService {
    static token = null;

    static setToken(token){
        EmailService.token = token;
    }

    static getToken() {
        return EmailService.token || localStorage.getItem('token');
    }

    static async get() {
        try {
            let response = await axios.request({
                url: `${baserUrl}/notifications/email`,
                headers: {
                    'Authorization': EmailService.getToken()
                }
            });
            return response.data;
        } catch(e) {
            AuthenticationService.handleCircuitBreak(e);
        }
    }

    static async set(emailList) {
        try {
            let response = await axios.request({
                url: `${baserUrl}/notifications/email/${emailList.id}`,
                method: 'put',
                headers: {
                    'Authorization': EmailService.getToken()
                },
                data: {
                    emails: emailList.emails
                }
            });
            return response.data;
        } catch(e) {
            AuthenticationService.handleCircuitBreak(e);
        }
    }

    static async getByID(id) {
        try {
            let response = await axios.request({
                url: `${baserUrl}/notifications/email/${id}`,
                headers: {
                    'Authorization': EmailService.getToken()
                }
            });
            return response.data;
        } catch(e) {
            AuthenticationService.handleCircuitBreak(e);
        }
    }
}

export class FeedbackService {
    static token = null;

    static setToken(token){
        FeedbackService.token = token;
    }

    static getToken() {
        return FeedbackService.token || localStorage.getItem('token');
    }

    static async get() {
        try {
            let response = await axios.request({
                url: `${baserUrl}/feedback`,
                headers: {
                    'Authorization': FeedbackService.getToken()
                }
            });
            return response.data;
        } catch(e) {
            AuthenticationService.handleCircuitBreak(e);
        }
    }

    static async getByID(id) {
        try {
            let response = await axios.request({
                url: `${baserUrl}/feedback/${id}`,
                headers: {
                    'Authorization': FeedbackService.getToken()
                }
            });
            return response.data;
        } catch(e) {
            AuthenticationService.handleCircuitBreak(e);
        }
    }
}

export class AuditService {
    static token = null;

    static setToken(token){
        AuditService.token = token;
    }

    static getToken() {
        return AuditService.token || localStorage.getItem('token');
    }

    static async get(filter) {
        try {
            let response = await axios.request({
                url: `${baserUrl}/logs`,
                method: 'post',
                headers: {
                    'Authorization': AuditService.getToken()
                },
                data: filter
            });
            return response.data;
        } catch(e) {
            AuthenticationService.handleCircuitBreak(e);
        }
    }
}

